import { render } from "./LoginPage.vue?vue&type=template&id=b07866be&scoped=true"
import script from "./LoginPage.vue?vue&type=script&lang=js"
export * from "./LoginPage.vue?vue&type=script&lang=js"

import "./LoginPage.vue?vue&type=style&index=0&id=b07866be&scoped=true&lang=css"

import exportComponent from "E:\\project\\exam\\web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b07866be"]])

export default __exports__